module.exports = __webpack_public_path__ + "static/img/exam_3.7577d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/exam_3.png
// module id = YTRR
// module chunks = 1